<script setup lang="ts">
import ButtonOutlined from '@/shared/components/button/ButtonOutlined.vue';
import ScanBarcodeSVG from '@shared/assets/icon/scan-barcode.svg';
import { useRouter } from 'vue-router';

const router = useRouter();

const scanQRCode = () => {
  router.replace({ name: 'SerialNumberQRCode' });
};
</script>

<template>
  <ButtonOutlined block class="qr-button" @click="scanQRCode">
    <template #iconLeft>
      <ScanBarcodeSVG class="scan-icon" />
    </template>
    Scan the QR Code
  </ButtonOutlined>
</template>

<style lang="less" scoped>
.qr-button {
  .scan-icon {
    width: 1.4rem;
    height: 1.4rem;
  }
}
</style>
